import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { Tag } from '@/components/elementary/Tag';
import Heading from '@/components/typography/Heading';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import type { GridCardProps } from '@/types/general';
import type { ServerRenderedEntry } from '@/types/helpers';
import styles from './IntegrationsCard.module.css';
import { TileIcon } from './shared/TileIcon';
export function IntegrationsCard(t0) {
  const $ = _c(28);
  const {
    icon,
    title,
    author,
    description,
    tag,
    serverProcessedHtmlDescription,
    serverProcessedHtmlContent
  } = t0;
  const t = useTranslations("IntegrationsCard");
  let t1;
  if ($[0] !== icon) {
    t1 = icon && <TileIcon icon={icon} size="medium" />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title && <Heading tag="h3" className={cn("text-left", styles["integrations-card-title"])}>{title}</Heading>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== author || $[5] !== t) {
    t3 = author && <Paragraph fontSize="bodyRegularSmall">{t("by")} {author}</Paragraph>;
    $[4] = author;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== description || $[8] !== serverProcessedHtmlDescription) {
    t4 = serverProcessedHtmlDescription ? <div className="mt-4 text-brand-black text-left block md:hidden">{serverProcessedHtmlDescription}</div> : <div className="mt-4 text-brand-black text-left block md:hidden"><CkEditorCSRRenderer defaultTypography="bodyMedium" variant="textOnly" htmlContent={description} /></div>;
    $[7] = description;
    $[8] = serverProcessedHtmlDescription;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex flex-col w-full items-start text-left">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <div className="flex flex-col items-start text-left">{t2}{t5}</div>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t1 || $[17] !== t6) {
    t7 = <div className="flex flex-col items-start gap-4"><div className="flex flex-row items-start gap-4">{t1}{t6}</div></div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== description || $[20] !== serverProcessedHtmlContent) {
    t8 = serverProcessedHtmlContent ? <div className="mt-4 text-brand-black text-left hidden md:block">{serverProcessedHtmlContent}</div> : <div className="mt-4 text-brand-black text-left hidden md:block"><CkEditorCSRRenderer defaultTypography="bodyMedium" variant="textOnly" htmlContent={description} /></div>;
    $[19] = description;
    $[20] = serverProcessedHtmlContent;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== tag) {
    t9 = tag && <Tag name={tag.name} variant={tag.variant?.variant} size="small" customColors={tag.customColors ? {
      backgroundColor: tag.customColors.backgroundColor?.color,
      textColor: tag.customColors.textColor?.color,
      borderColor: tag.customColors.borderColor?.color
    } : undefined} className="w-fit mt-3" />;
    $[22] = tag;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <div className="p-4 md:p-6 w-full">{t7}{t8}{t9}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}